import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notice"]
  static values = { text: String, from: String }

  connect() {
    this.noticeTarget.addEventListener("animationend", this.#finished)
  }

  disconnect() {
    this.noticeTarget.removeEventListener("animationend", this.#finished)
  }

  copy() {
    const text = this.fromValue ? this.#source().textContent : this.textValue
    navigator.clipboard.writeText(text).then(() => this.#showNotice("Copied"), () => this.#showNotice("Copy failed"))
  }

  // The nearest element matching `from` among the button's ancestors' descendants.
  #source() {
    for (let element = this.element.parentElement; element; element = element.parentElement) {
      const source = element.querySelector(this.fromValue)
      if (source) return source
    }
  }

  #showNotice(text) {
    const notice = this.noticeTarget
    notice.classList.remove("is-on")
    notice.textContent = ""
    void notice.offsetWidth
    notice.textContent = text
    notice.classList.add("is-on")
  }

  #finished = (event) => {
    if (event.target !== this.noticeTarget) return
    if (!String(event.animationName).startsWith("clipboard-copied")) return
    this.noticeTarget.classList.remove("is-on")
    this.noticeTarget.textContent = ""
  }
}
